module.exports = __webpack_public_path__ + "img/buscar_vehiculo.41648041.svg";